import { render, staticRenderFns } from "./creation-edit.vue?vue&type=template&id=121fd50a&scoped=true"
import script from "./creation-edit.vue?vue&type=script&lang=js"
export * from "./creation-edit.vue?vue&type=script&lang=js"
import style0 from "./creation-edit.vue?vue&type=style&index=0&id=121fd50a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121fd50a",
  null
  
)

export default component.exports